import type { ChatThread } from "@/features/chat/services/chatService";

const STORAGE_KEY_PREFIX = "knowgem_selected_chat_thread_";

export function getStorageKey(workspaceId: string | null | undefined): string {
	return `${STORAGE_KEY_PREFIX}${workspaceId ?? "no_workspace"}`;
}

export function normalizeThreadDates(thread: ChatThread): ChatThread {
	const now = new Date().toISOString();
	const createdAt =
		typeof thread.createdAt === "string" && !Number.isNaN(new Date(thread.createdAt).getTime())
			? thread.createdAt
			: now;
	const updatedAt =
		typeof thread.updatedAt === "string" && !Number.isNaN(new Date(thread.updatedAt).getTime())
			? thread.updatedAt
			: now;
	return { ...thread, createdAt, updatedAt };
}
